import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PublicLayout } from "@/components/site/PublicLayout";
import { IssueCard } from "@/components/site/IssueCard";

export default function IssuesArchivePage() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/issues?limit=100").then((r) => setIssues(r.data || [])).finally(() => setLoading(false));
  }, []);

  return (
    <PublicLayout>
      <section className="hero-wash border-b-2 border-[color:var(--coh-ink)]">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pt-14 sm:pt-20 pb-10">
          <div className="kicker">Archive</div>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-[-0.03em] text-[color:var(--coh-ink)]">All Cohnect issues</h1>
          <p className="mt-3 text-[color:var(--coh-ink-muted)] max-w-2xl">One weekly letter at a time. Warm, brief, and useful.</p>
        </div>
      </section>
      <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 pt-10">
        {loading ? (
          <div className="h-40 nb-box animate-pulse" />
        ) : issues.length === 0 ? (
          <div className="nb-box p-8 text-center text-[color:var(--coh-ink-muted)]">No published issues yet.</div>
        ) : (
          <div data-testid="issues-list" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {issues.map((i) => <IssueCard key={i.id} issue={i} />)}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
